export default __webpack_public_path__ + "static/media/Highlord's Greatsword.c7448663.jpg";